module.exports = __webpack_public_path__ + "static/media/ky.7a1c98fc.svg";